import type { QueryKey, UseQueryResult, UseQueryOptions, QueryOptions } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";
import client from "@/api/client/axios";
import type { GetItemsPositionOfferQueryResponse, GetItemsPositionOfferQueryParams, GetItemsPositionOffer400, GetItemsPositionOffer401, GetItemsPositionOffer403, GetItemsPositionOffer422, GetItemsPositionOffer429, GetItemsPositionOffer500 } from "../types/GetItemsPositionOffer";

export const getItemsPositionOfferQueryKey = (params: GetItemsPositionOfferQueryParams) =>     [{url:`/api/purchase-tenders/v1/items-position-offer`},...(params ? [params] : [])] as const;
      export function getItemsPositionOfferQueryOptions <TData = GetItemsPositionOfferQueryResponse, TError = GetItemsPositionOffer400 | GetItemsPositionOffer401 | GetItemsPositionOffer403 | GetItemsPositionOffer422 | GetItemsPositionOffer429 | GetItemsPositionOffer500>(params: GetItemsPositionOfferQueryParams, options: Partial<Parameters<typeof client>[0]> = {}): UseQueryOptions<TData, TError> {
        const queryKey = getItemsPositionOfferQueryKey(params);

        return {
          queryKey,
          queryFn: () => {
            
            return client<TData, TError>({
              method: "get",
              url: `/api/purchase-tenders/v1/items-position-offer`,
              params,
              
              ...options,
            }).then(res => res.data);
          },
        };
      };
      
/**
 * @link /api/purchase-tenders/v1/items-position-offer
 */

export function useGetItemsPositionOffer <TData = GetItemsPositionOfferQueryResponse, TError = GetItemsPositionOffer400 | GetItemsPositionOffer401 | GetItemsPositionOffer403 | GetItemsPositionOffer422 | GetItemsPositionOffer429 | GetItemsPositionOffer500>(params: GetItemsPositionOfferQueryParams, options: {
          query?: UseQueryOptions<TData, TError>,
          client?: Partial<Parameters<typeof client<TData, TError>>[0]>,
        } = {}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const { query: queryOptions, client: clientOptions = {} } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getItemsPositionOfferQueryKey(params);

  const query = useQuery<TData, TError>({
    ...getItemsPositionOfferQueryOptions<TData, TError>(params, clientOptions),
    ...queryOptions
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey as QueryKey;

  return query;
};
